<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import mixin from '../mixin';
    import SourceSet from './SourceSet.vue';
    import type { NewsItem } from '../../shared/types'

    export default defineComponent({
        components: { SourceSet },
        mixins: [mixin],
        props: {
            item: {
                type: Object as PropType<NewsItem>,
                required: true
            },
            readingTimeLabel: {
                type: String,
                required: false,
                default: 'min read'
            },
            culture: {
                type: String,
                required: false,
                default: 'en-GB'
            },
        }
    })
</script>

<template>
    <a :href="item.detailUrl"
       class="card cy-news-item is-shadowless has-background-transparent is-flex is-flex-direction-column">
        <div v-if="item.image && item.image.length"
             class="card-image is-clipped has-radius-large">
            <source-set :image-sets="item.image"
                        picture-class="image is-clipped is-3by2" />
        </div>
        <div class="card-content is-flex-grow-1 px-0">
            <h3 v-show="item.title"
                class="title cy-news-item-title is-4 mb-3">
                {{ item.title }}
            </h3>
            <div v-show="item.intro"
                 class="block is-size-9-desktop"
                 v-text="truncate(item.intro)" />
            <div class="media">
                <div v-if="item.author?.previewImage && item.author.previewImage.length"
                     class="media-left">
                    <source-set :image-sets="item.author.previewImage" />
                </div>
                <div class="media-content">
                    <p v-show="item.author?.name"
                       class="has-text-weight-bold">
                        {{ item.author?.name }}
                    </p>
                    <div class="is-flex is-gap-1">
                        <div class="has-text-weight-bold">{{ toDateStr(item.date, culture) }}</div>
                        <div v-show="item.readingTime">|</div>
                        <div v-show="item.readingTime">{{ item.readingTime }} {{ readingTimeLabel }}</div>
                    </div>
                </div>
            </div>
        </div>
    </a>
</template>
